import PropTypes from 'prop-types';
import { isNullOrUndefined } from '../../helpers/helpers';
import { formatBillingRate } from './ProjectBillingRateHelper';

const RATE_STACK_STYLE = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  fontSize: 13,
};

export default function RateStack({ record, fields }) {
  const items = fields.filter(({ value }) => !isNullOrUndefined(record[value]));
  if (!items.length) return '—';

  return (
    <div style={RATE_STACK_STYLE}>
      {items.map(({ value, abbrev }) => (
        <div key={value}>
          <span>{abbrev}:</span>
          {' '}
          {formatBillingRate(record[value])}
        </div>
      ))}
    </div>
  );
}

RateStack.propTypes = {
  record: PropTypes.object.isRequired,
  fields: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
};